import type { FullShipment } from '@fv/client-types'
import { calculateCostPerMile, distanceInMiles } from '@fv/models/core'

export function getLoadCheapestCostPerMile(load: FullShipment) {
  const quote = load.cheapestQuote
  const amount =
    quote && quote.amount > 0 ? (quote.amountUsd ?? quote.amount) : null
  const distance = distanceInMiles(load.distance, load.distanceUOM)

  return {
    amount,
    distance,
    costPerMile: amount != null ? calculateCostPerMile(amount, distance) : null,
  }
}
